/**
 * React Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mui/material/styles';
// Ensures MUI styled engine is initialized before Popper-based components render.
import styled from '@mui/material/styles/styled';
import App from './App';
import './index.css';
import './styles/zulbot-tokens.css';
import './styles/industry-tokens.css';

void styled;

const recoverFromStaleChunk = (reason) => {
  const text = String(reason?.message || reason || '');
  if (
    !text.includes('Failed to fetch dynamically imported module')
    && !text.includes('Importing a module script failed')
    && !text.includes('error loading dynamically imported module')
  ) {
    return;
  }

  const key = 'aviatto:stale-chunk-reload';
  if (sessionStorage.getItem(key) === '1') return;
  sessionStorage.setItem(key, '1');
  window.location.reload();
};

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  recoverFromStaleChunk(event.payload);
});

window.addEventListener('unhandledrejection', (event) => {
  recoverFromStaleChunk(event.reason);
});

window.addEventListener('load', () => {
  setTimeout(() => sessionStorage.removeItem('aviatto:stale-chunk-reload'), 1000);
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
